import { render, staticRenderFns } from "./TradesRecent.vue?vue&type=template&id=2bb9f90a&"
import script from "./TradesRecent.vue?vue&type=script&lang=js&"
export * from "./TradesRecent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports